var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0767 0.12275C10.674 -0.0412499 5.32267 -0.0405832 2.92333 0.12275C0.325333 0.300084 0.0193333 1.86942 0 6.00008C0.0193333 10.1234 0.322667 11.6994 2.92333 11.8774C5.32333 12.0408 10.674 12.0414 13.0767 11.8774C15.6747 11.7001 15.9807 10.1308 16 6.00008C15.9807 1.87675 15.6773 0.30075 13.0767 0.12275ZM6 8.66675V3.33342L11.3333 5.99542L6 8.66675Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.457191040df3dbbb4ab73594f2ac5931.svg";
export { ForwardRef as ReactComponent };